import "./personal_info.css"
import personal_img from "../../../assets/pers_img.png"
import pers_logo from "../../../assets/logo.svg"
import Form from 'react-bootstrap/Form';
import React, {useState, useEffect} from 'react'
import hr from "../../../assets/hr.svg"
import {Link} from "react-router-dom";
import {useNavigate} from "react-router-dom";
import {connect} from 'react-redux';
import {setPersonalData} from '../../../redux/personal_store';
import {useTranslation} from "react-i18next";
import Logout from "../../logout/Logout";
import {Spinner} from "react-bootstrap";
import axios from "axios";
import TooltipComponent from "../../country_tooltip/CountryTooltip";
import StateTooltipComponent from "../../state_tooltip/StateTooltip";

const HOST = `${process.env.REACT_APP_API_URL}/api/accounts/step1/`

function PersonalInfo({personalData, appData, setPersonalData}) {
    const {t} = useTranslation()
    const navigate = useNavigate()
    const [isMailingAddressDifferent, setIsMailingAddressDifferent] = useState(personalData.isMailingAddressDifferent);
    const [isPanelOpen, setIsPanelOpen] = useState(personalData.isMailingAddressDifferent);
    const [countries, setCountries] = useState([]);
    const [states, setState] = useState([])
    const [mailingStates, setMailingStates] = useState([])
    const [isReadyCountry, setIsReadyCountry] = useState(false)
    const [isReadyState, setIsReadyState] = useState(false)

    useEffect(() => {
        return () => {
            setPersonalData({isMailingAddressDifferent});
        };
    }, [isMailingAddressDifferent, setPersonalData])

    const [infoErrors, setInfoErrors] = useState({
        title: '',
        firstName: '',
        lastName: '',
        middleName: '',
        birth: '',
        ssn: '',
        confirmSsn: '',
        phone: '',
        maritalStatus: '',
        idenType: '',
        idenNumber: '',
        issueDate: '',
        expDate: '',
        permAddress: '',
        address2: '',
        city: '',
        country: '',
        zipCode: '',
        state: '',
        mailingCountry: '',
        mailingAddress2: '',
        mailingCity: '',
        mailingZipCode: '',
        mailingState: '',
        trustName: '',
        trustCountry: ''
    })

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/accounts/getCountriesFiltered`, {
                headers: {
                    "ngrok-skip-browser-warning": "69420",
                    "Access-Control-Allow-Origin": "*",
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                }
            }
        )
            .then(({data}) => {
                const countryNames = data.map((country) => {
                    return {
                        value: country.cont_code,
                        label: country.cont_name
                    }
                });

                setCountries(countryNames);
                setIsReadyCountry(true)

            })
            .catch((err) => {
                console.log(err.message);
            });

    }, []);

    useEffect(() => {
        if (countries.length) {
            if (personalData.state) {
                getStates(personalData.country, '1')
            }

            if (personalData.mailingState) {
                getStates(personalData.mailingCountry, '2')
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [countries]);

    const isValidDate = (dateString) => {
        const regex = /^\d{2}\/\d{2}\/\d{4}$/;

        if (!regex.test(dateString)) {
            return false;
        }

        const parts = dateString.split('/');
        const year = parseInt(parts[2], 10)
        const month = parseInt(parts[0], 10) - 1;
        const day = parseInt(parts[1], 10);
        const date = new Date(year, month, day);

        return (
            date.getDate() === day &&
            date.getMonth() === month &&
            date.getFullYear() === year
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setInfoErrors({
            title: '',
            firstName: '',
            lastName: '',
            middleName: '',
            birth: '',
            ssn: '',
            confirmSsn: '',
            phone: '',
            maritalStatus: '',
            idenType: '',
            idenNumber: '',
            issueDate: '',
            expDate: '',
            permAddress: '',
            address2: '',
            city: '',
            country: '',
            zipCode: '',
            state: '',
            mailingCountry: '',
            mailingAddress: '',
            mailingAddress2: '',
            mailingCity: '',
            mailingZipCode: '',
            mailingState: '',
            trustName: '',
            trustCountry: ''
        });

        let isValid = true;

        if (!personalData.title) {
            setInfoErrors((prevErrors) => ({
                ...prevErrors,
                title: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!personalData.firstName) {
            setInfoErrors((prevErrors) => ({
                ...prevErrors,
                firstName: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!personalData.lastName) {
            setInfoErrors((prevErrors) => ({
                ...prevErrors,
                lastName: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!personalData.phone) {
            setInfoErrors((prevErrors) => ({
                ...prevErrors,
                phone: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!personalData.country) {
            setInfoErrors((prevErrors) => ({
                ...prevErrors,
                country: t('errors.select_country_error'),
            }));
            isValid = false;
        }

        if (appData.account_type === "speciality") {
            if (!personalData.trustCountry) {
                setInfoErrors((prevErrors) => ({
                    ...prevErrors,
                    trustCountry: t('errors.select_country_error'),
                }));
                isValid = false;
            }

            if (!personalData.trustName) {
                setInfoErrors((prevErrors) => ({
                    ...prevErrors,
                    trustName: t('errors.required_field'),
                }));
                isValid = false;
            }
        }

        if (!personalData.idenNumber) {
            setInfoErrors((prevErrors) => ({
                ...prevErrors,
                idenNumber: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!personalData.birth || !isValidDate(personalData.birth)) {
            setInfoErrors((prevErrors) => ({
                ...prevErrors,
                birth: t('errors.valid_date')
            }));
            isValid = false;
        } else {
            const currentDate = new Date();
            const dobDate = new Date(personalData.birth);
            const age = currentDate.getFullYear() - dobDate.getFullYear();

            if (age < 18) {
                setInfoErrors((prevErrors) => ({
                    ...prevErrors,
                    birth: t('errors.years_old_error'),
                }));
                isValid = false;
            }
        }

        if (appData.account_type !== "speciality") {
            if (!personalData.maritalStatus) {
                setInfoErrors((prevErrors) => ({
                    ...prevErrors,
                    maritalStatus: t('errors.required_field'),
                }));
                isValid = false;
            }
        }

        if (!personalData.idenType) {
            setInfoErrors((prevErrors) => ({
                ...prevErrors,
                idenType: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (appData.citizenship_status !== "non_resident") {
            if (!personalData.ssn) {
                setInfoErrors((prevErrors) => ({
                    ...prevErrors,
                    ssn: t('errors.required_field'),
                }));
                isValid = false;
            } else if (
                (appData.account_type === "speciality" && appData.specialtyAccountType === "trust2") &&
                personalData.ssn.length !== 10
            ) {
                setInfoErrors((prevErrors) => ({
                    ...prevErrors,
                    ssn: t('errors.tax_enter_characters'),
                }));
                isValid = false;
            } else if (appData.account_type !== "speciality" && appData.specialtyAccountType !== "trust2" && personalData.ssn.length !== 11) {
                setInfoErrors((prevErrors) => ({
                    ...prevErrors,
                    ssn: t('errors.enter_characters'),
                }));
                isValid = false;
            }
        }

        if (appData.citizenship_status !== "non_resident") {
            if (!personalData.confirmSsn) {
                setInfoErrors((prevErrors) => ({
                    ...prevErrors,
                    confirmSsn: t('errors.required_field'),
                }));
                isValid = false;
            }else if (personalData.confirmSsn !== personalData.ssn && appData.account_type === "speciality" && appData.specialtyAccountType !== "trust1") {
                setInfoErrors((prevErrors) => ({
                    ...prevErrors,
                    confirmSsn: t('errors.conf_tax_error'),
                }));
                isValid = false;
            }else if (personalData.confirmSsn !== personalData.ssn && appData.specialtyAccountType === "trust1") {
                setInfoErrors((prevErrors) => ({
                    ...prevErrors,
                    confirmSsn: t('errors.conf_ssn_error'),
                }));
                isValid = false;
            }else if (
                appData.account_type === "speciality" && appData.specialtyAccountType !== "trust1" &&
                personalData.ssn.length !== 10
            ) {
                setInfoErrors((prevErrors) => ({
                    ...prevErrors,
                    confirmSsn: t('errors.tax_enter_characters')
                }));
                isValid = false;
            } else if (appData.account_type !== "speciality" && appData.specialtyAccountType === "trust2" && personalData.ssn.length !== 11) {
                setInfoErrors((prevErrors) => ({
                    ...prevErrors,
                    confirmSsn: t('errors.enter_characters'),
                }));
                isValid = false;
            }
        }

        if (!personalData.issueDate || !isValidDate(personalData.issueDate)) {
            setInfoErrors((prevErrors) => ({
                ...prevErrors,
                issueDate: t('errors.required_field'),
            }));
            isValid = false;
        } else {
            const currentDate = new Date();
            const issueDate = new Date(personalData.issueDate);

            if (issueDate > currentDate) {
                setInfoErrors((prevErrors) => ({
                    ...prevErrors,
                    issueDate: t('errors.exp_earlier_date_error'),
                }));
                isValid = false;
            }
        }

        if (!personalData.expDate || !isValidDate(personalData.expDate)) {
            setInfoErrors((prevErrors) => ({
                ...prevErrors,
                expDate: t('errors.required_field'),
            }));
            isValid = false;
        } else {
            const currentDate = new Date();
            const selectedExpDate = new Date(personalData.expDate);

            if (selectedExpDate < currentDate) {
                setInfoErrors((prevErrors) => ({
                    ...prevErrors,
                    expDate: t('errors.exp_date_error'),
                }));
                isValid = false;
            } else if (personalData.issueDate && selectedExpDate <= new Date(personalData.issueDate)) {
                setInfoErrors((prevErrors) => ({
                    ...prevErrors,
                    expDate: t('errors.exp_issue_date_error'),
                }));
                isValid = false;
            }
        }

        if (!personalData.permAddress) {
            setInfoErrors((prevErrors) => ({
                ...prevErrors,
                permAddress: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!personalData.city) {
            setInfoErrors((prevErrors) => ({
                ...prevErrors,
                city: t('errors.required_field'),
            }));
            isValid = false;
        }

        const zipCodeRegex = /^\d{5}(-\d{4})?$/;
        if (!zipCodeRegex.test(personalData.zipCode) && personalData.country === 'USA') {
            setInfoErrors((prevErrors) => ({
                ...prevErrors,
                zipCode: t('errors.zip_code_format'),
            }));
            isValid = false;
        }

        if (!personalData.state) {
            setInfoErrors((prevErrors) => ({
                ...prevErrors,
                state: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!personalData.mailingCountry && isMailingAddressDifferent) {
            setInfoErrors((prevErrors) => ({
                ...prevErrors,
                mailingCountry: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!personalData.mailingCity && isMailingAddressDifferent) {
            setInfoErrors((prevErrors) => ({
                ...prevErrors,
                mailingCity: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!personalData.mailingState && isMailingAddressDifferent) {
            setInfoErrors((prevErrors) => ({
                ...prevErrors,
                mailingState: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!personalData.mailingAddress && isMailingAddressDifferent) {
            setInfoErrors((prevErrors) => ({
                ...prevErrors,
                mailingAddress: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!zipCodeRegex.test(personalData.mailingZipCode) && isMailingAddressDifferent && personalData.country === 'USA') {
            setInfoErrors((prevErrors) => ({
                ...prevErrors,
                mailingZipCode: t('errors.zip_code_format'),
            }));
            isValid = false;
        }

        if (isValid) {

            setPersonalData(personalData);
            if (!appData.app_id) alert('Missing app id')

            try {
                await personalApp()

                if (appData.sub_account_type === "omnibus") {
                    navigate('/signature')
                } else {
                    navigate('/financial')
                }
            } catch (error) {
                setInfoErrors((prevErrors) => ({
                    ...prevErrors,
                    submitError: error.message,
                }));
            }
        }
    }

    const getStates = async (country, type) => {
        setIsReadyState(false);
        const countryObject = countries.find(i => i.value === country || i.label === country);

        if (!countryObject) {
            setIsReadyState(true);
            return;
        }

        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/accounts/getStates/${countryObject.value}`, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                }
            });

            const stateData = response.data;
            const stateNames = stateData.map((state) => ({
                subdivision_name: state.subdivision_name,
                code: state.code
            }));

            setIsReadyState(true);

            if (type === '1') {
                setState(stateNames);
            } else {
                setMailingStates(stateNames);
            }
        } catch (err) {
            console.log(err.message);
        }
    }

    const handleInputChange = (e) => {
        let {name, value} = e.target;

        if (name === 'ssn' || name === 'confirmSsn') {
            value = value.replace(/\D/g, '');

            if (value.length === 9) {
                value = appData.account_type === "speciality" && appData.specialtyAccountType !== "trust1"
                    ? value.substr(0, 2) + "-" + value.substr(2, 7)
                    : value.substr(0, 3) + '-' + value.substr(3, 2) + '-' + value.substr(5, 4);
            }

            setPersonalData((prevData) => ({
                ...prevData,
                [name]: value
            }));
        }

        if (name === 'ssn') {
            if (!value) {
                setInfoErrors((prevErrors) => ({
                    ...prevErrors,
                    ssn: t('errors.required_field'),
                }));
            } else {
                if ((value.length === 11 && value.match(/^\d{3}-\d{2}-\d{4}$/)) || (value.length === 10 && value.match(/^\d{2}-\d{7}$/))) {
                    setInfoErrors((prevErrors) => ({
                        ...prevErrors,
                        ssn: '',
                    }));
                } else if (appData.account_type === "speciality" && appData.specialtyAccountType !== "trust1") {
                    setInfoErrors((prevErrors) => ({
                        ...prevErrors,
                        ssn: t('errors.tax_enter_characters')
                    }));
                } else {
                    setInfoErrors((prevErrors) => ({
                        ...prevErrors,
                        ssn: t('errors.enter_characters'),
                    }));
                }
            }
        }

        if (name === 'confirmSsn') {
            if (value !== personalData.ssn && appData.account_type === "speciality" && appData.specialtyAccountType !== "trust1") {
                setInfoErrors((prevErrors) => ({
                    ...prevErrors,
                    confirmSsn: t('errors.conf_tax_error'),
                }));
            }else if(value !== personalData.ssn && appData.specialtyAccountType === "trust1"){
                setInfoErrors((prevErrors) => ({
                    ...prevErrors,
                    confirmSsn: t('errors.conf_ssn_error'),
                }));
            } else {
                if ((value.length === 11 && value.match(/^\d{3}-\d{2}-\d{4}$/)) || (value.length === 10 && value.match(/^\d{2}-\d{7}$/))) {
                    setInfoErrors((prevErrors) => ({
                        ...prevErrors,
                        confirmSsn: '',
                    }));
                } else if (appData.account_type === "speciality" && appData.specialtyAccountType !== "trust1") {
                    setInfoErrors((prevErrors) => ({
                        ...prevErrors,
                        confirmSsn: t('errors.tax_enter_characters'),
                    }));
                } else {
                    setInfoErrors((prevErrors) => ({
                        ...prevErrors,
                        confirmSsn: t('errors.enter_characters'),
                    }));
                }
            }
        }

        if (name === 'birth' || name === 'issueDate' || name === 'expDate') {
            const numericValue = value.replace(/\D/g, '');

            if (numericValue.length <= 2) {
                value = numericValue;
            } else if (numericValue.length <= 4) {
                value = `${numericValue.substr(0, 2)}/${numericValue.substr(2)}`;
            } else {
                value = `${numericValue.substr(0, 2)}/${numericValue.substr(2, 2)}/${numericValue.substr(4, 4)}`;
            }

            const isValid = isValidDate(value);

            setInfoErrors((prevErrors) => ({
                ...prevErrors,
                [name]: isValid ? '' : t('errors.valid_date'),
            }));

            if (isValid) {
                const currentDate = new Date();
                const dateValue = new Date(value);

                if (name === 'birth') {
                    const age = currentDate.getFullYear() - dateValue.getFullYear();
                    if (age < 18) {
                        setInfoErrors((prevErrors) => ({
                            ...prevErrors,
                            [name]: t('errors.years_old_error'),
                        }));
                    }
                } else if (name === 'issueDate') {
                    if (dateValue > currentDate) {
                        setInfoErrors((prevErrors) => ({
                            ...prevErrors,
                            [name]: t('errors.exp_earlier_date_error'),
                        }));
                    }
                } else if (name === 'expDate') {
                    if (dateValue < currentDate) {
                        setInfoErrors((prevErrors) => ({
                            ...prevErrors,
                            [name]: t('errors.exp_date_error'),
                        }));
                    } else if (personalData.issueDate && dateValue <= new Date(personalData.issueDate)) {
                        setInfoErrors((prevErrors) => ({
                            ...prevErrors,
                            [name]: t('errors.exp_issue_date_error'),
                        }));
                    }
                }
            }
        }

        if (name === 'zipCode' || name === 'mailingZipCode') {
            value = value.replace(/\D/g, '').substr(0, 9);

            if (value.length === 9) {
                value = `${value.substr(0, 5)}-${value.substr(5, 4)}`;
            }

            const zipCodeRegex = /^\d{5}(-\d{4})?$/;
            if (!zipCodeRegex.test(value)) {
                setInfoErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: t('errors.zip_code_format')
                }));
            } else {
                setInfoErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: '',
                }));
            }
        }

        setPersonalData({
            ...personalData,
            [name]: value,
        });
    };

    const formatDateInput = (dateString) => {
        if (!dateString) return dateString
        return dateString.replace(/\D/g, '').replace(/(\d{2})(\d{2})(\d{4})/, '$1/$2/$3');
    };

    const formatDateInputAPI = (dateString) => {
        if (!dateString) return dateString
        return dateString.replace(/\D/g, '').replace(/(\d{2})(\d{2})(\d{4})/, '$3-$1-$2');
    };

    const onChangeCountry = async (value) => {
        setPersonalData({...personalData, 'country': value});
        await getStates(value, '1')
    }

    const onChangeTrustCountry = async (value) => {
        setPersonalData({...personalData, 'trustCountry': value});
    }

    const onChangeState = (value) => {
        setPersonalData({...personalData, 'state': value});
    }

    const onChangeMailingState = (value) => {
        setPersonalData({...personalData, 'mailingState': value});
    }

    const onChangeMailingCountry = async (value) => {
        setPersonalData({...personalData, 'mailingCountry': value});
        await getStates(value, '2')
    }

    const handleCheckboxChange = () => {
        setIsMailingAddressDifferent(!isMailingAddressDifferent);
        setIsPanelOpen(!isPanelOpen);

        setPersonalData(prevPersonalData => ({
            ...prevPersonalData,
            isMailingAddressDifferent: !isMailingAddressDifferent,
            mailingDiff: isMailingAddressDifferent ? 'N' : 'Y',
        }));
    };

    const getPersonalInfoValue = () => {
        return {
            MailingDiff: isMailingAddressDifferent ? 'Y' : 'N',
            TrustTaxType: appData.account_type !== 'speciality' ? '' : (appData.specialtyAccountType === 'trust1' ? 'SSN' : 'TaxID'),
        };
    };

    const personalApp = async () => {
        try {
            const URL = HOST + appData.app_id;
            const params = getPersonalInfoValue()

            const parsedPersonalData = {
                ...personalData,
                birth: formatDateInputAPI(personalData.birth),
                expDate: formatDateInputAPI(personalData.expDate),
                issueDate: formatDateInputAPI(personalData.issueDate)
            };

            const response = await axios.put(URL, {...parsedPersonalData, ...params}, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                }
            });

            if (response.data && response.data.status && ['404', '500'].includes(response.data.status)) {
                throw new Error(response.data.message || 'Unknown error occurred');
            }

        } catch (error) {
            throw error;
        }
    };

    return (
        <div className="personal_info">
            <div className="personal_left_side">
                <img src={pers_logo} alt=""/>
                <img style={{paddingTop: "12%"}} src={personal_img} alt=""/>
            </div>
            <div className="personal_right_side">
                <Logout/>
                <div id="error-container"></div>
                <p className="personal_heading">{t('personal.welcome')}
                    <span> {personalData.firstName} {personalData.lastName}.</span> {t('personal.welcome_pls')}</p>
                <p className="personal_info_heading">{t('personal.personal_info')} {appData.account_type === "custodial" ? "(Custodian)" : ''}</p>
                <form onSubmit={handleSubmit}>
                    <div className="personal_info_inputs">
                        {appData.account_type === "speciality" && (
                            <>
                                <div className="personal_input_error">
                                    <input className="personal_input" placeholder={t('specialty.trust_company_name')}
                                           type="text"
                                           name="trustName"
                                           value={personalData.trustName}
                                           onChange={handleInputChange}
                                    />

                                    {infoErrors.trustName && <p className="info_error">{infoErrors.trustName}</p>}
                                </div>

                                <div className="personal_input_error" style={{textAlign: "center"}}>
                                    {
                                        isReadyCountry ?
                                            <select className="personal_country_select"
                                                    value={personalData.trustCountry}
                                                    onChange={(e) => onChangeTrustCountry(e.target.value)}
                                                    name="trustCountry">
                                                <option value="" selected disabled>{t('specialty.country_of')}</option>
                                                {countries.map((country, index) => <option value={country.value}
                                                                                           key={index.toString()}>{country.label}</option>)}
                                            </select>
                                            : <Spinner animation="border" role="status" variant="personalData">
                                                <span className="visually-hidden">Loading...</span>
                                            </Spinner>
                                    }

                                    {isReadyCountry && infoErrors.trustCountry &&
                                        <p className="info_error">{infoErrors.trustCountry}</p>}
                                </div>
                            </>
                        )}

                        <div className="personal_input_error">
                            <Form.Select aria-label="Default select example"
                                         name="title"
                                         value={personalData.title}
                                         onChange={handleInputChange}
                            >
                                <option value="" selected disabled>{t('personal.title')}</option>
                                <option value="Mr.">{t('personal.mr')}</option>
                                <option value="Ms.">{t('personal.ms')}</option>
                                <option value="Mrs.">{t('personal.mrs')}</option>
                                <option value="Dr.">{t('personal.dr')}</option>
                            </Form.Select>
                            {infoErrors.title && <p className="info_error">{infoErrors.title}</p>}

                        </div>
                        <div className="personal_input_error">
                            <input className="personal_input" placeholder={t('personal.first_name')}
                                   type="text"
                                   name="firstName"
                                   value={personalData.firstName}
                                   onChange={handleInputChange}
                            />
                            {infoErrors.firstName && <p className="info_error">{infoErrors.firstName}</p>}
                        </div>

                        <div className="personal_input_full_error">
                            <input placeholder={t('specialty.middle_name')} className="personal_input_full" type="text"
                                   name="middleName"
                                   value={personalData.middleName}
                                   onChange={handleInputChange}
                            />
                        </div>

                        <div className="personal_input_error">
                            <input className="personal_input" placeholder={t('personal.last_name')}
                                   type="text"
                                   name="lastName"
                                   value={personalData.lastName}
                                   onChange={handleInputChange}
                            />
                            {infoErrors.lastName && <p className="info_error">{infoErrors.lastName}</p>}
                        </div>

                        <div className="personal_input_error">
                            <input
                                className="personal_input"
                                placeholder={t('personal.date_of_birth')}
                                type="text"
                                name="birth"
                                value={formatDateInput(personalData.birth)}
                                onChange={handleInputChange}
                            />
                            {infoErrors.birth && <p className="info_error">{infoErrors.birth}</p>}
                        </div>

                        {appData.citizenship_status !== "non_resident" &&
                            <>
                                <div className="personal_input_error">
                                    <input
                                        className="personal_input"
                                        placeholder={
                                            appData.account_type === "speciality" && appData.specialtyAccountType === "trust1"
                                                ? 'SSN XXX-XX-XXXX'
                                                : appData.account_type === "speciality" && appData.specialtyAccountType !== "trust1"
                                                    ? 'Tax ID XX-XXXXXXX'
                                                    : t('personal.ssn')
                                        }
                                        type="text"
                                        name="ssn"
                                        maxLength={
                                            appData.account_type === "speciality" && appData.specialtyAccountType !== "trust1"
                                                ? 10
                                                : 11
                                        }
                                        value={personalData.ssn}
                                        onChange={handleInputChange}
                                    />

                                    {infoErrors.ssn && <p className="info_error">{infoErrors.ssn}</p>}
                                </div>

                                <div className="personal_input_error">
                                    <input className="personal_input"
                                           placeholder={
                                               appData.account_type === "speciality" && appData.specialtyAccountType === "trust1"
                                                   ? 'Confirm SSN XXX-XX-XXXX' :
                                                   appData.account_type === "speciality" && appData.specialtyAccountType !== "trust1"
                                                       ? 'Confirm Tax ID XX-XXXXXXX' : 'Confirm SSN XXX-XX-XXXX'
                                           }
                                           type="text"
                                           maxLength={
                                               appData.account_type === "speciality" && appData.specialtyAccountType !== "trust1"
                                                   ? 10
                                                   : 11
                                           }
                                           name="confirmSsn"
                                           value={personalData.confirmSsn}
                                           onChange={handleInputChange}
                                    />
                                    {infoErrors.confirmSsn && <p className="info_error">{infoErrors.confirmSsn}</p>}
                                </div>
                            </>
                        }
                        <div className="personal_input_full_error">
                            <input className="personal_input_full" placeholder={t('personal.mobile_phone')}
                                   type="number"
                                   name="phone"
                                   value={personalData.phone}
                                   onChange={handleInputChange}
                            />
                            {infoErrors.phone && <p className="info_error">{infoErrors.phone}</p>}
                        </div>

                        {appData.account_type !== "speciality" && (
                            <div className="personal_input_full_error">
                                <Form.Select aria-label="Default select example"
                                             name="maritalStatus"
                                             value={personalData.maritalStatus}
                                             onChange={handleInputChange}
                                >
                                    <option value="" selected disabled>{t('personal.marital_status')}</option>
                                    <option value="Single">{t('personal.single')}</option>
                                    <option value="Married">{t('personal.married')}</option>
                                    <option value="Divorced">{t('personal.divorced')}</option>
                                    <option value="Widow">{t('personal.widow')}</option>
                                </Form.Select>
                                {infoErrors.maritalStatus && <p className="info_error">{infoErrors.maritalStatus}</p>}
                            </div>
                        )}

                        <p className="personal-headings">{t('personal.identification')}</p>

                        <div className="personal_input_error">
                            <Form.Select aria-label="Default select example"
                                         name="idenType"
                                         value={personalData.idenType}
                                         onChange={handleInputChange}
                            >
                                <option value="" selected disabled>{t('personal.iden_type')}</option>
                                <option value="drivers_license">{t('personal.state_dl')}</option>
                                <option value="identity_card">{t('personal.state_id')}</option>
                                <option value="passport">{t('personal.passport')}</option>
                            </Form.Select>
                            {infoErrors.idenType && <p className="info_error">{infoErrors.idenType}</p>}
                        </div>
                        <div className="personal_input_error">
                            <input className="personal_input" placeholder={t('personal.iden_number')} type="number"
                                   name="idenNumber"
                                   value={personalData.idenNumber}
                                   onChange={handleInputChange}
                            />
                            {infoErrors.idenNumber && <p className="info_error">{infoErrors.idenNumber}</p>}
                        </div>
                        <div className="personal_input_error">
                            <input className="personal_input"
                                   placeholder={t('personal.issue_date')}
                                   type="text"
                                   name="issueDate"
                                   value={formatDateInput(personalData.issueDate)}
                                   onChange={handleInputChange}
                            />
                            {infoErrors.issueDate && <p className="info_error">{infoErrors.issueDate}</p>}

                        </div>
                        <div className="personal_input_error">
                            <input className="personal_input"
                                   placeholder={t('personal.expiration_date')}
                                   type="text"
                                   name="expDate"
                                   value={formatDateInput(personalData.expDate)}
                                   onChange={handleInputChange}
                            />
                            {infoErrors.expDate && <p className="info_error">{infoErrors.expDate}</p>}
                        </div>

                        <p className="personal-headings">{t('personal.permanent_address')}</p>

                        <div className="personal_input_error">
                            <input className="personal_input" placeholder={t('personal.permanent_address')}
                                   type="text"
                                   name="permAddress"
                                   value={personalData.permAddress}
                                   onChange={handleInputChange}
                            />
                            {infoErrors.permAddress && <p className="info_error">{infoErrors.permAddress}</p>}

                        </div>
                        <div className="personal_input_error">
                            <input className="personal_input" placeholder={t('personal.address2')}
                                   type="text"
                                   name="address2"
                                   value={personalData.address2}
                                   onChange={handleInputChange}
                            />
                        </div>
                        <div className="personal_input_error">
                            <input className="personal_input" placeholder={t('personal.city')}
                                   type="text"
                                   name="city"
                                   value={personalData.city}
                                   onChange={handleInputChange}
                            />
                            {infoErrors.city && <p className="info_error">{infoErrors.city}</p>}
                        </div>

                        <div className="personal_input_error">
                            {
                                isReadyCountry ?
                                    <>
                                        <select className="personal_country_select" value={personalData.country}
                                                onChange={(e) => onChangeCountry(e.target.value)} name="country">
                                            <option value="" selected disabled>{t('personal.select_country')}</option>
                                            {countries.map((country, index) => <option value={country.value}
                                                                                       key={index.toString()}>{country.label}</option>)}
                                        </select>
                                        <TooltipComponent/>
                                    </>

                                    : <Spinner animation="border" role="status" variant="personalData">
                                        <span className="visually-hidden">Loading...</span>
                                    </Spinner>
                            }

                            {isReadyCountry && infoErrors.country && <p className="info_error">{infoErrors.country}</p>}
                        </div>

                        <div className="personal_input_error">
                            <input
                                className="personal_input"
                                placeholder={t('personal.zip_code')}
                                type="text"
                                name="zipCode"
                                value={personalData.zipCode}
                                onChange={handleInputChange}
                            />
                            {infoErrors.zipCode && <p className="info_error">{infoErrors.zipCode}</p>}
                        </div>
                        <div className="personal_input_error">
                            {
                                isReadyState ?
                                    <>
                                        <select className="personal_state_select"
                                                onChange={(e) => onChangeState(e.target.value)} name="state"
                                                value={personalData.state}>
                                            <option value="" selected disabled>{t('personal.select_state')}</option>
                                            {states.map((state) => (
                                                <option value={state.code}
                                                        key={state.code}>{state.subdivision_name}</option>
                                            ))}
                                        </select>
                                        <StateTooltipComponent/>
                                    </>
                                    : <span></span>
                            }
                            {isReadyState && infoErrors.state && <p className="info_error">{infoErrors.state}</p>}
                        </div>
                    </div>
                    <img style={{width: "100%", paddingTop: "5%"}} src={hr} alt=""/>

                    <div className="personal_check">
                        <Form.Check
                            aria-label="option 1"
                            name="mailingDiff"
                            onChange={handleCheckboxChange}
                            checked={isMailingAddressDifferent}
                        />
                        <span className="checkbox_text">{t('personal.different_address')}</span>
                    </div>

                    {isPanelOpen && (
                        <div>
                            <div style={{
                                display: "flex",
                                gap: "20px",
                                paddingTop: "3%",
                                flexWrap: "wrap"
                            }}>
                                <div className="mailing_inputs">
                                    <input className="aff_inputs" type="text"
                                           placeholder={t('personal.mailing_address')}
                                           name="mailingAddress"
                                           value={personalData.mailingAddress}
                                           onChange={handleInputChange}/>
                                    {infoErrors.mailingAddress &&
                                        <p className="info_error">{infoErrors.mailingAddress}</p>}
                                </div>
                                <div className="mailing_inputs">
                                    <input className="aff_inputs" type="text"
                                           placeholder={t('personal.mailing_address2')}
                                           name="mailingAddress2"
                                           value={personalData.mailingAddress2}
                                           onChange={handleInputChange}/>
                                </div>
                                <div className="mailing_inputs">
                                    <input className="aff_inputs" type="text" placeholder={t('personal.mailing_city')}
                                           name="mailingCity"
                                           value={personalData.mailingCity}
                                           onChange={handleInputChange}/>
                                    {infoErrors.mailingCity &&
                                        <p className="info_error">{infoErrors.mailingCity}</p>}
                                </div>
                                <div className="personal_input_error">
                                    {
                                        isReadyCountry ?
                                            <>
                                                <select className="personal_country_select"
                                                        value={personalData.mailingCountry}
                                                        onChange={(e) => onChangeMailingCountry(e.target.value)}
                                                        name="mailingCountry">
                                                    <option value="" selected disabled>{t('personal.mailing_country')}</option>
                                                    {countries.map((country, index) => <option value={country.value}
                                                                                               key={index.toString()}>{country.label}</option>)}
                                                </select>
                                                <TooltipComponent/>
                                            </>
                                            : <Spinner animation="border" role="status" variant="personalData">
                                                <span className="visually-hidden">Loading...</span>
                                            </Spinner>
                                    }
                                    {isReadyCountry && infoErrors.mailingCountry &&
                                        <p className="info_error">{infoErrors.mailingCountry}</p>}
                                </div>
                                <div className="mailing_inputs">
                                    <input
                                        className="personal_input"
                                        placeholder={t('personal.mailing_zip_code')}
                                        type="text"
                                        name="mailingZipCode"
                                        value={personalData.mailingZipCode}
                                        onChange={handleInputChange}
                                    />
                                    {infoErrors.mailingZipCode &&
                                        <p className="info_error">{infoErrors.mailingZipCode}</p>}
                                </div>
                                <div className="mailing_inputs">
                                    {
                                        isReadyState ?
                                            <>
                                                <select className="personal_state_select"
                                                        onChange={(e) => onChangeMailingState(e.target.value)}
                                                        name="mailingState"
                                                        value={personalData.mailingState}>
                                                    <option value="" selected disabled>{t('personal.mailing_state')}</option>
                                                    {mailingStates.map((mailingState) => <option
                                                        value={mailingState.code}
                                                        key={mailingState.code}>{mailingState.subdivision_name}</option>)}
                                                </select>
                                                <StateTooltipComponent/>
                                            </>
                                            : <Spinner animation="border" role="status" variant="personalData">
                                                <span className="visually-hidden">Loading...</span>
                                            </Spinner>
                                    }

                                    {isReadyState && infoErrors.mailingState &&
                                        <p className="info_error">{infoErrors.mailingState}</p>}
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="personal_btn">
                        <Link style={{textDecoration: "none"}} to="/">
                            <button className="personal_back_btn">{t('back_btn')}</button>
                        </Link>
                        <button className="personal_continue_btn" type="submit">{t('next_btn')}</button>
                    </div>
                    <div>
                        {infoErrors.submitError && (
                            <div style={{color: 'red', textAlign: "center"}}>
                                {infoErrors.submitError}
                            </div>
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    personalData: state.personalData,
    appData: state.appData
});

const mapDispatchToProps = (dispatch) => ({
    setPersonalData: (personalData) => dispatch(setPersonalData(personalData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PersonalInfo);